import React from "react";

export function ClosingBanner() {
    return (
        <div className="bg-red-600 border-b border-red-700">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <p className="text-lg text-white text-center">
                    THESAI will be closing in 3 weeks. Please move to{' '}
                    <a
                        href="https://glossa.live"
                        target="_blank"
                        rel="noreferrer"
                        className="font-semibold underline hover:text-red-100"
                    >
                        glossa.live
                    </a>
                    {' '}— We would love to serve you there more! If you need help transferring your funds, please contact us at{' '}
                    <a
                        href="mailto:info@glossa.live"
                        className="font-semibold underline hover:text-red-100"
                    >
                        info@glossa.live
                    </a>
                    .
                </p>
            </div>
        </div>
    );
}
